'use strict';

var toggleProduct = require('core/wishlist/components/toggleProduct');

var wishlistHelpers = require('core/wishlist/components/helpers');
var modalShowLists = require('core/wishlist/components/modalShowLists');
var toastHelpers = require('core/components/toast');

toggleProduct.methods.eventClickHeart = function(event) {
    event.preventDefault();
    var wishlistpid = event.currentTarget.dataset.wishlistpid;
    if (window.UncachedData.customer.isAuthenticated) {
        $.ajax({
            url: window.CachedData.wishlist.urls.toggleProduct,
            method: 'POST',
            dataType: 'json',
            data: {
                pid: wishlistpid,
                wishlistId: window.UncachedData.wishlist.default.id,
                quantity: 1,
                options: {}
            },
            success: function(data) {
                var $html = $(data.renderedTemplate);
                if (!data.error && $html.length) {
                    var actionType = $html.find('.selected').length ? 'add' : 'remove';
                    modalShowLists.methods.updateWishlistProducts($html);
                    modalShowLists.methods.updateModalListDataState();
                    wishlistHelpers.updateUncachedData({
                        actionType: actionType,
                        pid: wishlistpid
                    });
                    wishlistHelpers.updateLinkData();
                    wishlistHelpers.openToast({
                        pid: wishlistpid,
                        wishlistName: window.UncachedData.wishlist.default.name,
                        wishlistUrl: window.UncachedData.wishlist.default.url,
                        wishlistId: window.UncachedData.wishlist.default.id,
                        wishlistActionType: actionType
                    });
                } else {
                    toastHelpers.methods.show('danger', data.message, true);
                }
            },
            error: function() {
                toastHelpers.methods.show('danger', 'Error registering product', true);
            }
        });
    } else {
        module.exports.methods.toggleProductGuest(event.currentTarget.dataset);
    }
};

module.exports = toggleProduct;
